import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Add a timeline event to a case's timeline subcollection.
 * Writes to: {collectionName}/{caseId}/timeline
 *
 * @param {string} caseId - The case document ID
 * @param {string} collectionName - "pending" or "disposed"
 * @param {object} eventData - Event details
 * @param {string} eventData.type - Event type
 * @param {string} eventData.title - Short title for the event
 * @param {string} eventData.description - Description of what happened
 * @param {string} eventData.performedBy - UID of the user who performed the action
 * @param {string} eventData.performedByName - Display name of the user
 * @param {object} [eventData.changes] - Object with property-level changes: { "Field Name": { old: "...", new: "..." } }
 * @param {object} [eventData.metadata] - Optional extra data
 */
export async function addTimelineEvent(caseId, collectionName, eventData) {
  if (!caseId || !collectionName) return;

  try {
    const timelineRef = collection(db, collectionName, caseId, "timeline");
    await addDoc(timelineRef, {
      type: eventData.type || "unknown",
      title: eventData.title || "",
      description: eventData.description || "",
      performedBy: eventData.performedBy || "",
      performedByName: eventData.performedByName || "",
      timestamp: serverTimestamp(),
      changes: eventData.changes || {},
      metadata: eventData.metadata || {},
    });
  } catch (error) {
    console.error("Error adding timeline event:", error);
  }
}
